/**
 * Back/forward detection shared by the layout (scroll restoration) and kept-alive pages
 * (whether an activation is a return or a fresh entry).
 *
 * Vue Router keeps an incrementing `position` in `history.state`. A popstate rewrites it
 * before the route guards run, a push only writes it once the navigation is confirmed —
 * so during a guard a lower position means "this is a back/forward".
 */

function currentPosition(): number {
  const state = window.history.state as {position?: number} | null;
  return Number(state?.position ?? 0);
}

let lastPosition = currentPosition();
let lastWasPop = false;

/** True while a back/forward navigation is in flight. Call from a route guard. */
export function isPopNavigation(): boolean {
  return currentPosition() < lastPosition;
}

/** True when the last confirmed navigation was a back/forward. Call after it resolved. */
export function wasPopNavigation(): boolean {
  return lastWasPop;
}

/** Records the navigation that just resolved; call once per confirmed navigation. */
export function commitNavigation(): void {
  lastWasPop = isPopNavigation();
  lastPosition = currentPosition();
}
